<h3 mat-dialog-title class="lt">{{ data.title | translate }}</h3>
<mat-dialog-content class="container">
    <mat-icon [color]="color">{{ icon }}</mat-icon>
    <p [ngClass]="{ paid: data.pay, lt: true }" *ngFor="let text of data.texts">{{ text | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button *ngIf="!data.pay" [color]="color" class="mat-custom-btn" mat-flat-button mat-dialog-close color="accent">{{ 'LABEL.OK' | translate }}</button>
    <button *ngIf="data.pay" class="download-btn mat-custom-btn" color="accent" (click)="downloadTickets()" mat-flat-button>
          <mat-icon class="mat-icon-small">downloads</mat-icon>
          <span> {{ 'LABEL.TICKETS' | translate }} </span>
        </button>
</mat-dialog-actions>
